module.exports = require("@babel/runtime/helpers/assertThisInitialized");